<template>
  <div class="rs-segment-info tw-mb-2 -tw-mx-6">
    <div
      v-if="!segment || !segment.id"
      class="sf-bg-warning-subtle sf-pad-v-3 sf-pad-h-3 sf-layer-border-bottom"
    >
      <a
        v-if="!partnerSegmentName"
        class="sf-btn"
        @click="openSaveSegmentModal"
      >
        <div class="sf-btn-icon-left fa fa-pie-chart sf-c-primary"></div>
        <span>{{ I18n.t('companies_overview.segments_new.save_as') }}</span>
      </a>

      <a
        v-if="partnerSegmentName"
        class="sf-btn"
        data-testid="update-partner-segment"
        @click="updatePartnerSegment(partnerSegmentID)"
      >
        <div class="sf-btn-icon-left fa fa-pie-chart sf-c-primary"></div>
        <span>Update "{{ partnerSegmentName }}" in Partner Section</span>
      </a>
    </div>

    <div
      v-if="isSegmentModified"
      class="sf-bg-warning-subtle sf-pad-v-3 sf-pad-h-3 sf-layer-border-bottom"
    >
      <div class="sf-text sf-c-warning-darker sf-below-3">
        {{ I18n.t('companies_overview.segments_new.filters_have_changed') }}
      </div>
      <div class="sf-level sf-level-vertical sf-level-small">
        <div class="sf-level-item">
          <div
            v-if="canUpdateSegment && (!segment || !segment.recommended)"
            v-tooltip="
              marketSegment
                ? I18n.t(
                    'companies_overview.segments_new.market_segment_cannot_save'
                  )
                : ''
            "
            class="sf-inline-block"
          >
            <a
              :class="{ 'sf-disabled': marketSegment }"
              :disabled="marketSegment"
              class="sf-btn rs-update-segment"
              @click="updateSegmentWithConfirm"
            >
              <div
                class="
                  sf-btn-icon-left
                  fa fa-solid fa-triangle-exclamation
                  sf-c-warning
                "
              ></div>
              <span>{{
                I18n.t('companies_overview.segments_new.update')
              }}</span>
            </a>
          </div>
        </div>

        <div class="sf-level-item rs-create-segment">
          <a class="sf-btn" @click="openSaveAsSegmentModal">
            <div class="sf-btn-icon-left fa fa-pie-chart sf-c-primary"></div>
            <span>{{
              I18n.t('companies_overview.segments_new.save_as_new')
            }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState({
      segment: (state) => state.segments.segment,
      lite: (state) => state.lite,
    }),

    ...mapGetters(['isSegmentModified']),

    marketSegment() {
      return !!this.segment.partner
    },

    partnerSegmentID() {
      return this.$route.query.ms_id
    },

    partnerSegmentName() {
      return this.partnerSegmentID && this.$route.query.ms_name
    },
    canUpdateSegment() {
      return this.segment?.permissions.update
    },
  },
  methods: {
    ...mapActions([
      'openSaveSegmentModal',
      'openSaveAsSegmentModal',
      'updateSegment',
      'updatePartnerSegment',
    ]),

    updateSegmentWithConfirm() {
      if (this.marketSegment) return
      window.sfConfirm({
        question: I18n.t('companies_overview.segments_new.confirm_update'),
        onConfirm: async () => {
          try {
            await this.updateSegment()
          } catch (e) {
            alert(e.body.errorMessage)
          }
        },
      })
    },
  },
}
</script>
